(() => {
  const PAGE_SIZE = 10;
  let archivePromise;
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const dateText = value => new Date(value + 'T12:00:00Z').toLocaleDateString('en-GB', {day:'numeric', month:'short', year:'numeric', timeZone:'UTC'});
  function loadArchive(sourceUrl) {
    if (!archivePromise) {
      const url = sourceUrl || window.EtPdp?.config?.reviewsUrl || 'assets/trustpilot-reviews.json';
      archivePromise = fetch(url).then(response => {
        if (!response.ok) throw new Error('Reviews unavailable');
        return response.json();
      }).then(data => {
        if (!Array.isArray(data.reviews) || data.reviews.some(r => !Number.isInteger(r.rating) || r.rating < 1 || r.rating > 5 || typeof r.author !== 'string' || typeof r.body !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(r.date))) throw new Error('Invalid archive');
        return data;
      }).catch(error => { archivePromise = undefined; throw error; });
    }
    return archivePromise;
  }
  function stars(rating) {
    const node = element('span', 'tp-stars');
    node.setAttribute('role', 'img');
    node.setAttribute('aria-label', rating + ' out of 5 stars');
    for (let n = 1; n <= 5; n++) {
      const star = element('span', n > rating ? 'empty' : '', '★');
      star.setAttribute('aria-hidden', 'true');
      node.append(star);
    }
    return node;
  }
  function reviewCard(review) {
    const card = element('article', 'tp-archive-card');
    const head = element('div', 'tp-archive-card-head');
    const name = element('h3', '', review.author || 'Trustpilot reviewer');
    head.append(name, stars(review.rating));
    const date = element('time', '', dateText(review.date));
    date.dateTime = review.date;
    card.append(head, date, element('blockquote', '', review.body));
    return card;
  }
  async function mount(root) {
    root.replaceChildren(element('p', 'tp-loading', 'Loading the collected Trustpilot reviews…'));
    root.setAttribute('aria-busy', 'true');
    let data;
    try { data = await loadArchive(root.dataset.reviewsUrl); }
    catch {
      if (!root.isConnected) return;
      root.removeAttribute('aria-busy');
      const message = element('p', '', 'The reviews could not load. Please try again.');
      message.setAttribute('role', 'alert');
      const retry = element('button', 'outline-button', 'Try again');
      retry.type = 'button';
      retry.addEventListener('click', () => mount(root));
      root.replaceChildren(message, retry);
      return;
    }
    if (!root.isConnected) return;
    root.removeAttribute('aria-busy');
    root.replaceChildren();
    const intro = element('p', 'tp-archive-intro', data.reviews.length.toLocaleString('en-GB') + ' collected reviews, including every star rating.');
    const meta = element('p', 'tp-archive-meta', 'Saved ' + dateText(data.collectedAt) + '. This is our saved collection, not the full live Trustpilot feed. ');
    const controls = element('div', 'tp-review-controls');
    function control(label, id, tag) {
      const wrapper = element('div');
      const caption = element('label', '', label); caption.htmlFor = id;
      const input = element(tag); input.id = id;
      wrapper.append(caption, input); controls.append(wrapper); return input;
    }
    const search = control('Search reviews', 'tp-search', 'input');
    search.type = 'search'; search.placeholder = 'Fit, delivery, quality…'; search.autocomplete = 'off';
    const rating = control('Star rating', 'tp-rating', 'select');
    const counts = [1,2,3,4,5].map(n => data.reviews.filter(r => r.rating === n).length);
    [['all','All ratings'], ...[5,4,3,2,1].map(n => [String(n), `${n} star${n === 1 ? '' : 's'} (${counts[n-1].toLocaleString('en-GB')})`])].forEach(([value, label]) => {
      const option = element('option', '', label); option.value = value; rating.append(option);
    });
    const sort = control('Sort by', 'tp-sort', 'select');
    [['newest','Newest first'],['highest','Highest rating'],['lowest','Lowest rating']].forEach(([value,label]) => {
      const option = element('option', '', label); option.value = value; sort.append(option);
    });
    const status = element('p', 'tp-list-status'); status.setAttribute('role', 'status'); status.setAttribute('aria-live','polite'); status.tabIndex = -1;
    const list = element('div', 'tp-review-list');
    const pagination = element('div', 'tp-pagination');
    const previous = element('button', 'outline-button', 'Previous'); previous.type = 'button';
    const pageLabel = element('span');
    const next = element('button', 'outline-button', 'Next'); next.type = 'button';
    pagination.append(previous, pageLabel, next);
    root.append(intro, meta, controls, status, list, pagination);
    let page = 0;
    function render() {
      const query = search.value.trim().toLocaleLowerCase('en-GB');
      const result = data.reviews.filter(r => (rating.value === 'all' || r.rating === Number(rating.value)) && (!query || (r.body + ' ' + r.author).toLocaleLowerCase('en-GB').includes(query)));
      result.sort((a,b) => (sort.value === 'highest' ? b.rating-a.rating : sort.value === 'lowest' ? a.rating-b.rating : 0) || b.date.localeCompare(a.date));
      const pages = Math.ceil(result.length / PAGE_SIZE);
      page = Math.min(page, Math.max(0, pages-1));
      const start = page * PAGE_SIZE;
      status.textContent = result.length ? `Showing ${start+1}–${Math.min(start+PAGE_SIZE,result.length)} of ${result.length.toLocaleString('en-GB')} collected reviews` : 'No reviews match your search. Try another word or choose All ratings.';
      list.replaceChildren(...result.slice(start, start+PAGE_SIZE).map(reviewCard));
      previous.disabled = page === 0; next.disabled = page + 1 >= pages;
      pagination.hidden = pages <= 1;
      pageLabel.textContent = `Page ${page+1} of ${pages}`;
    }
    search.addEventListener('input', () => {page = 0; render();});
    [rating, sort].forEach(input => input.addEventListener('change', () => {page = 0; render();}));
    function move(direction) {page += direction; render(); status.focus();}
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    render();
  }
  window.EverteeReviews = {mount};
})();

